import { createContext } from 'react';

// A primitive level ensures all cards update when the run's mutable model levels up.
// Outside Scene, including when a saved run exists, dynamic artwork uses base art.
export default createContext(null);
